// BlueMouse GmbH Helpers
import errorsHandler from './helpers/errors.js';
import initSelect2 from './helpers/select2.js';
import initAutosize from './helpers/autosize.js';
import initBootstrapTable from './helpers/bootstrapTable.js';
import initDatepicker from './helpers/datepicker.js';
import * as tooltip from './helpers/tooltip.js';
import {
	addNewPrototype,
	initDeleteBtn,
	initForms,
	dateHandler,
	exportExcelHandler,
	modalAjaxForm,
	formatNumber,
	bmRoundPrice,
	reverseFormat,
	addressHandler,
	getAddressInfo,
	filterHandler,
	calcTotal,
	productPrototypeHandler,
	formWithTabs,
	initFormatPhoneNumber,
	updateOptionsSelect2,
	getPrrcInfo,
	getUserInfo,
	removePrototype
} from './helpers/helper.js';

$( document ).ready(function() {
	// Show errors as alert
	errorsHandler();

	// Init all functions
	initSelect2();
	initAutosize();
	initBootstrapTable();
	initDatepicker();
	initDeleteBtn();
	initForms();
	initFormatPhoneNumber();
	exportExcelHandler();
	filterHandler();

	//Initialize all tooltip for the input fields
	if($('[data-function="tooltip-input"]').length){
		tooltip.init('[data-function="tooltip-input"]');
	}

	// Removes the after-loaded class, usually used in the css file to activate the animation effects
	$('.after-loaded').removeClass('after-loaded');


	if($('#address-add-edit-container').length){
		addEditAddressHandler();
	}

	if($('#product-add-edit-container').length){
		addEditProductHandler();
	}

	if($('#order-add-edit-container').length){
		addEditOrderHandler();
	}

	if($('#activity-list-container').length){
		indexLogActivityHandler();
	}

	if($('#user-add-edit-container').length){
		addEditUserHandler();
	}
});

function addEditAddressHandler(){
	// Save the current tab so that it opens again when saving
	formWithTabs(() => {
		autosize.update($('.autosize'));

		if($('[role="tab"].active').prop('id') == 'address-info-tab'){
			$('.address-delete-btn').show();
		}else{
			$('.address-delete-btn').hide();
		}
	});
	if($('[role="tab"].active').prop('id') == 'address-info-tab'){
		$('.address-delete-btn').show();
	}else{
		$('.address-delete-btn').hide();
	}


	/**** Project Tab *****/
	// Hide or show the closed at field in the project view
	const projectsCloseHandler = () =>{
		$('[data-function="projects-close-handler"]').unbind('change.projects-close-handler').bind('change.projects-close-handler', function(){
			if($(this).is(':checked')){
				$(this).parents('.row').eq(0).find('[data-id="closed_at"]').parents('.form-group').eq(0).removeClass('d-none');
			}else{
				$(this).parents('.row').eq(0).find('[data-id="closed_at"]').parents('.form-group').eq(0).addClass('d-none');
			}
		});
	}
	projectsCloseHandler();
	// Create a new project row on button click
	addNewPrototype('add-new-prototype-project', () => {
		initDatepicker();
		initAutosize();
		projectsCloseHandler();
	});
	/**** END Project Tab *****/


	// Copy the address data in the delivery box
	$('[data-function="copy-address-info-to-delivery"]').unbind('click.copy-address-info-to-delivery').bind('click.copy-address-info-to-delivery', function(){
		const company = $('#company').val();
		const address_2 = $('#address_2').val();
		const address_3 = $('#address_3').val();
		const street = $('#street').val();
		const zip = $('#zip').val();
		const city = $('#city').val();

		if(
			$('#delivery_address_company').val()
			|| $('#delivery_address_address_2').val()
			|| $('#delivery_address_address_3').val()
			|| $('#delivery_address_street').val()
			|| $('#delivery_address_zip').val()
			|| $('#delivery_address_city').val()){

			$('#modal-confirm-copy').modal();

			$('[data-function="confirm-copy"]').unbind('click.confirm-copy').bind('click.confirm-copy', function(){
				$('#modal-confirm-copy').modal('hide');

				$('#delivery_address_company').val(company);
				$('#delivery_address_address_2').val(address_2);
				$('#delivery_address_address_3').val(address_3);
				$('#delivery_address_street').val(street);
				$('#delivery_address_zip').val(zip);
				$('#delivery_address_city').val(city);
			});
		}else{
			$('#delivery_address_company').val(company);
			$('#delivery_address_address_2').val(address_2);
			$('#delivery_address_address_3').val(address_3);
			$('#delivery_address_street').val(street);
			$('#delivery_address_zip').val(zip);
			$('#delivery_address_city').val(city);
		}
	});

	// Copy the address data in the invoice box
	$('[data-function="copy-address-info-to-invoice"]').unbind('click.copy-address-info-to-invoice').bind('click.copy-address-info-to-invoice', function(){
		const company = $('#company').val();
		const address_2 = $('#address_2').val();
		const address_3 = $('#address_3').val();
		const street = $('#street').val();
		const zip = $('#zip').val();
		const city = $('#city').val();

		if(
			$('#invoice_address_company').val()
			|| $('#invoice_address_address_2').val()
			|| $('#invoice_address_address_3').val()
			|| $('#invoice_address_street').val()
			|| $('#invoice_address_zip').val()
			|| $('#invoice_address_city').val()){

			$('#modal-confirm-copy').modal();

			$('[data-function="confirm-copy"]').unbind('click.confirm-copy').bind('click.confirm-copy', function(){
				$('#modal-confirm-copy').modal('hide');

				$('#invoice_address_company').val(company);
				$('#invoice_address_address_2').val(address_2);
				$('#invoice_address_address_3').val(address_3);
				$('#invoice_address_street').val(street);
				$('#invoice_address_zip').val(zip);
				$('#invoice_address_city').val(city);
			});
		}else{
			$('#invoice_address_company').val(company);
			$('#invoice_address_address_2').val(address_2);
			$('#invoice_address_address_3').val(address_3);
			$('#invoice_address_street').val(street);
			$('#invoice_address_zip').val(zip);
			$('#invoice_address_city').val(city);
		}
	});

	// Change icon when clicking on the collapse btn
	$('#shipping-method-container').on('hidden.bs.collapse', function () {
		let id = $(this).attr('id');
		$(`[href="#${id}"]`).removeClass('btn-minus');
		$(`[href="#${id}"]`).addClass('btn-plus');
	});
	$('#shipping-method-container').on('shown.bs.collapse', function () {
		let id = $(this).attr('id');
		$(`[href="#${id}"]`).removeClass('btn-plus');
		$(`[href="#${id}"]`).addClass('btn-minus');
	});


	/**** Contact Tab *****/
	// add a new contact
	$('[data-function="add-contact"]').unbind('click.add-contact').bind('click.add-contact', function(){
		$(`#add-edit-contact input, #add-edit-contact select, #add-edit-contact textarea`).not('[type="checkbox"]').val('');
		$('#add-edit-contact [type="checkbox"]').prop("checked", false);
		$('#add-edit-contact [name="contact[contact_salutation_id]"]').val(1)

		$('#add-edit-contact [data-function="delete-record"]').addClass('d-none');

		$('#add-edit-contact').removeClass('d-none');
		$('#contacts-list').addClass('d-none');
	});

	// Edit a contact
	const editContacts = () => {
		$('[data-function="edit-contact"]').unbind('click.edit-contact').bind('click.edit-contact', function(){
			const contact = JSON.parse(atob($(this).parents('tr').data('contact')));

			Object.keys(contact).forEach(key => {
				const field = $(`#add-edit-contact [name="contact[contact_${key}]"]`);

				if(field.length){
					if(field.attr('type') == 'checkbox'){
						if(contact[key]){
							field.prop("checked", true);
						}
					}else if(field.attr('type') == 'email' || field.attr('type') == 'tel'){
						let aField = field.next().find('a');
						if(aField.length){
							let oldHref = aField.attr('href');

							if(oldHref.includes('mailto:')){
								aField.attr('href', 'mailto:' + contact[key]);
							}else if(oldHref.includes('tel:')){
								aField.attr('href', 'tel:' + contact[key]);
							}
						}

						field.val(contact[key]);
					}else{
						field.val(contact[key]);
					}
				}
			});

			$('#add-edit-contact [data-function="delete-record"]').data('url', `/api/address/contact/${contact.id}/delete-warnings`);
			$('#add-edit-contact [data-function="delete-record"]').removeClass('d-none');


			$('#add-edit-contact').removeClass('d-none');
			$('#contacts-list').addClass('d-none');

			autosize.update($('.autosize'));
		});
	}
	editContacts();
	$('#contacts-list .bootstrap-table').on('post-body.bs.table', function() {
		editContacts();
	});

	// Go back to contact list
	$('[data-function="back-to-contact-list"]').unbind('click.back-to-contact-list').bind('click.back-to-contact-list', function(){
		$('#add-edit-contact').addClass('d-none');
		$('#contacts-list').removeClass('d-none');

		$(`#add-edit-contact input, #add-edit-contact select, #add-edit-contact textarea`).not('[type="checkbox"]').val('');
		$('#add-edit-contact [type="checkbox"]').prop("checked", false);
		$('#add-edit-contact [name="contact[contact_salutation_id]"]').val(1)
	});
	/**** END Contact Tab *****/


	/**** Activity Tab *****/
	// add a new activity
	$('[data-function="add-activity"]').unbind('click.add-activity').bind('click.add-activity', function(){
		$(`#add-edit-activity input, #add-edit-activity select, #add-edit-activity textarea`).not('[type="checkbox"]').val('');

		$(`#add-edit-activity [name="activities[user_id]"]`).val(window.userId);
		$(`#add-edit-activity [name="activities[date]"]`).val(moment().format('DD.MM.YYYY'));

		$('#add-edit-activity [data-function="delete-record"]').addClass('d-none');

		$('#add-edit-activity').removeClass('d-none');
		$('#activities-list').addClass('d-none');
	});

	// Edit a activity
	const editActivities = () => {
		$('[data-function="edit-activity"]').unbind('click.edit-activity').bind('click.edit-activity', function(){
			const activity = JSON.parse(atob($(this).parents('tr').data('activity')));

			Object.keys(activity).forEach(key => {
				const field = $(`#add-edit-activity [name="activities[${key}]"]`);

				if(field.length){
					let value = activity[key];

					if(key == 'date'){
						value = moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY');
					}

					field.val(value);
				}
			});

			$('#add-edit-activity [data-function="delete-record"]').data('url', `/api/address/activity/${activity.id}/delete-warnings`);
			$('#add-edit-activity [data-function="delete-record"]').removeClass('d-none');


			$('#add-edit-activity').removeClass('d-none');
			$('#activities-list').addClass('d-none');

			autosize.update($('.autosize'));
		});
	}
	editActivities();
	$('#activities-list .bootstrap-table').on('post-body.bs.table', function() {
		editActivities();
	});

	// Go back to activity list
	$('[data-function="back-to-activities-list"]').unbind('click.back-to-activities-list').bind('click.back-to-activities-list', function(){
		$('#add-edit-activity').addClass('d-none');
		$('#activities-list').removeClass('d-none');

		$(`#add-edit-activity input, #add-edit-activity select, #add-edit-activity textarea`).not('[type="checkbox"]').val('');
	});
	/**** END Activity Tab *****/
}

function addEditProductHandler(){
	// Save the current tab so that it opens again when saving
	formWithTabs();

	// Show or hide the medical products inputs
	$('[data-function="medical-product-handler"]').unbind('change.medical-product-handler').bind('change.medical-product-handler', function(){
		if($(this).is(':checked')){
			$('[data-id="medical-product-detail-form"]').removeClass('d-none');
		}else{
			$('[data-id="medical-product-detail-form"]').addClass('d-none');
		}
	});

	// Show or hide the implant_id input
	$('[data-function="implant-handler"]').unbind('change.implant-handler').bind('change.implant-handler', function(){
		if($(this).val() == 'yes'){
			$('[data-id="implant-id"]').removeClass('d-none');
		}else{
			$('[data-id="implant-id"]').addClass('d-none');
		}
	});

	// Show or hide the expiring inputs
	$('[data-function="exp-handler"]').unbind('change.exp-handler').bind('change.exp-handler', function(){
		if($(this).is(':checked')){
			$('[data-id="exp-detail-form"]').removeClass('d-none');
		}else{
			$('[data-id="exp-detail-form"]').addClass('d-none');
		}
	});

	// Show or hide the expiring inputs
	$('[data-function="maintenance-handler"]').unbind('change.maintenance-handler').bind('change.maintenance-handler', function(){
		if($(this).is(':checked')){
			$('[data-id="maintenance-detail-form"]').removeClass('d-none');
		}else{
			$('[data-id="maintenance-detail-form"]').addClass('d-none');
		}
	});

	// When uploading an image, it shows it as a preview and fills the hidden field with the value
	$('[data-function="upload-image-handler"]').unbind('change.upload-image-handler').bind('change.upload-image-handler', function(){
		// Set the hidden field as true, so we know that an image was uploaded (image is saved in a session)
		$('#uploadImageData').val(1);

		// Show the image as a preview when uploaded
		if (this.files && this.files[0]) {
			var reader = new FileReader();

			reader.onload = function(e) {
				$('.image-preview-container').find('img').remove();
				$('.image-preview-container').prepend('<img class="img-fluid mb-4" src="'+e.target.result+'" alt="" />');


				$('.image-container').remove();
				$('.image-preview-container').removeClass('d-none');
			}

			// convert to base64 string
			reader.readAsDataURL(this.files[0]);
		}
	});

	// Manage the remove preview image button
	$('[data-function="remove-preview-image"]').unbind('click.remove-preview-image').bind('click.remove-preview-image', function(){
		// Set the hidden field as false, so we know that the uploaded image (saved in the session) has not to be uploaded
		$('#uploadImageData').val(0);

		$('.image-preview-container').addClass('d-none');
		$('.image-preview-container').find('img').remove();
	});

	// Set the delete image modal as ajax
	modalAjaxForm(
		$('#modal-delete-image'),
		(data) => {
			if(data.success){
				$('.image-container').remove();
				$('.image-upload-field-container').removeClass('d-none');
				toastr.success('Bild wurde entfernt.');
			}else{
				toastr.error('Bild wurde nicht entfernt.');
			}
		}
	);

	// Calc the landed price
	$('[data-function="calc-landed-price"]').unbind('change.calc-landed-price').bind('change.calc-landed-price', function(){
		let currency = $('#purchase_currency').val();
		let price = $('#purchase_price').val();

		let val = reverseFormat(price);
        if(currency != 'chf'){
        	val = val * 1.1;
        }

		$('#landed_price').val(formatNumber(val));
		$('#landed_price').trigger('change');
	});

	// Calc the margin
	$('[data-function="calc-margin"]').unbind('change.calc-margin').bind('change.calc-margin', function(){
		let tarifPrice = reverseFormat($('#tarif_price').val());
		let landedPrice = reverseFormat($('#landed_price').val());

		let margin = ((tarifPrice - landedPrice) / tarifPrice) * 100;
		$('#margin').val(formatNumber(margin));
	});

	// Calc the tarif price
	$('[data-function="calc-tarif-price"]').unbind('change.calc-tarif-price').bind('change.calc-tarif-price', function(){
		let margin = reverseFormat($(this).val());
		let landedPrice = reverseFormat($('#landed_price').val());

		let tarifPrice = landedPrice / (1 - (margin / 100));
		$('#tarif_price').val(formatNumber(tarifPrice));
	});


	// Disable or enalbe the date field when changing the select box (CE, DC, ISO)
	$('[data-function="enable-disable-date-field"]').unbind('change.enable-disable-date-field').bind('change.enable-disable-date-field', function(){
		let target = $(this).data('target');

		if($(this).val() == 'date'){
			$(target).removeAttr('disabled');
		}else{
			$(target).attr('disabled', true);
		}
	});
}

function indexLogActivityHandler(){
	dateHandler();
}

function addEditOrderHandler(reload = true){
	if(reload){
		tooltip.init('[data-function="tooltip-handler"]');

		// callback function when changing the address
		const addressChangeCallback = () => {
			$('[data-id="delivery_name"]').val(pageVar.address.delivery_info.company);
			$('[data-id="delivery_name_2"]').val(pageVar.address.delivery_info.address_2);
			$('[data-id="delivery_name_3"]').val(pageVar.address.delivery_info.address_3);
			$('[data-id="delivery_street"]').val(pageVar.address.delivery_info.street);
			$('[data-id="delivery_city"]').val(pageVar.address.delivery_info.city);
			$('[data-id="delivery_zip"]').val(pageVar.address.delivery_info.zip);
			$('[data-id="delivery_country_code"]').val(pageVar.address.delivery_info.country_code);
			$('[data-id="delivery_phone"]').val(pageVar.address.delivery_info.phone);
			$('[data-id="delivery_email"]').val(pageVar.address.delivery_info.email);
		}

		addressHandler(addressChangeCallback);


		// Show a warning if the customer order number already exists
		$('[data-function="customer-order-nr-handler"]').unbind('change.customer-order-nr-handler').bind('change.customer-order-nr-handler', function(){
			const customerOrderNr = btoa($(this).val());

			let url = `/api/order/check-customer-order-number/${customerOrderNr}`;
			axios.get(url)
				.then(function (response) {
					let data = response.data;

					if(data.success){
						$('#modal-customer-order-nr-already-exists').modal({backdrop: 'static'});
					}
				});
		});

		// Set the order as an internal order for the employees
		$('[data-function="demo-order-handler"]').unbind('change.demo-order-handler').bind('change.demo-order-handler', function(){
			if($(this).is(':checked')){
				$('html').addClass('cursor-progress');

				$('#address_id').val(1);
				initSelect2($('#address_id'));

				let url = '/api/user/get-logged-user-info';
				axios.get(url)
					.then(function (response) {
						let user = response.data;

						//Remove disable class from containers
						$('.disabled').removeClass('disabled');

						$('#user_id').val(user.id).trigger('change');
						//$('#user_id').prop('disabled', true);

						$('[data-id="delivery_name"]').val(`${user.firstname} ${user.lastname}`);
						$('[data-id="delivery_name_2"]').val('');
						$('[data-id="delivery_name_3"]').val('');
						$('[data-id="delivery_street"]').val(user.street);
						$('[data-id="delivery_city"]').val(user.city);
						$('[data-id="delivery_zip"]').val(user.zip);
						$('[data-id="delivery_country_code"]').val(user.country_code);

						$('html').removeClass('cursor-progress');
					});
			}
		});

		// Change the shipment price when changing the shimpent method
		$('[data-function="shipping-price-handler"]').unbind('change.shipping-price-handler').bind('change.shipping-price-handler', function(){
			let shipping_method_id = $(this).val();
			let shipping_price = '';
			pageVar.address.shipping_methods.forEach(function(method){
				if(method.id == shipping_method_id){
					shipping_price = method.price;
					if(!shipping_price){
						shipping_price = 0;
					}
				}
			});

			$('[data-id="shipping_price"]').val(shipping_price);

			calcTotal();
		});

		// Create a new product row on button click
		addNewPrototype('add-new-prototype-product', () => addEditOrderHandler(false), () => calcTotal());
		// Create a new position row on button click
		addNewPrototype('add-new-prototype-position', () => addEditOrderHandler(false), () => calcTotal());

		// Remove the disable attr from the dispatch_date when the order is set to be sent in the future
		$('[data-function="future-order-handler"]').unbind('change.future-order-handler').bind('change.future-order-handler', function(){
			if($(this).is(':checked')){
				$('[data-id="dispatch_date"]').prop('disabled', false);
			}else{
				$('[data-id="dispatch_date"]').val('');
				$('[data-id="dispatch_date"]').prop('disabled', true);
			}
		});

		// Make the position list sortable
	    Sortable.create(sortable, {
	    	animation: 150,
	    	ghostClass: 'bg-info',
	    	handle: '.handle'
		});

		// Make the position list sortable
	    Sortable.create(sortable2, {
	    	animation: 150,
	    	ghostClass: 'bg-info',
	    	handle: '.handle'
		});

		// Disable submit button on form submit
		let allowSubmit = true;
		$('#order-form').submit(function(){
			if(allowSubmit){
				$('button[type="submit"]').addClass('disabled');

				allowSubmit = false;
			}else{
				return false;
			}
		});
	}

	initSelect2();
	initAutosize();


	//Calc the price of the order
	$('[data-function="amount-handler"], [data-id="shipping_price"]').unbind('keyup.amount-handler').bind('keyup.amount-handler', function(){
		calcTotal();
	});

	productPrototypeHandler();

	if(reload){
		getAddressInfo($('[data-function="address-handler"]').val(), (data) => {
			pageVar.address = data;
		});

		calcTotal();
	}
}

function addEditUserHandler(){
	// When uploading an image, it shows it as a preview and fills the hidden field with the value
	$('[data-function="upload-image-handler"]').unbind('change.upload-image-handler').bind('change.upload-image-handler', function(){
		// Set the hidden field as true, so we know that an image was uploaded (image is saved in a session)
		$('#uploadSignatureData').val(1);

		// Show the image as a preview when uploaded
		if (this.files && this.files[0]) {
			var reader = new FileReader();

			reader.onload = function(e) {
				$('.image-preview-container').find('img').remove();
				$('.image-preview-container').prepend('<img class="img-fluid mb-4" src="'+e.target.result+'" alt="" />');


				$('.image-container').remove();
				$('.image-preview-container').removeClass('d-none');
			}

			// convert to base64 string
			reader.readAsDataURL(this.files[0]);
		}
	});

	// Manage the remove preview image button
	$('[data-function="remove-preview-image"]').unbind('click.remove-preview-image').bind('click.remove-preview-image', function(){
		// Set the hidden field as false, so we know that the uploaded image (saved in the session) has not to be uploaded
		$('#uploadSignatureData').val(0);

		$('.image-preview-container').addClass('d-none');
		$('.image-preview-container').find('img').remove();
	});

	// Set the delete image modal as ajax
	modalAjaxForm(
		$('#modal-delete-image'),
		(data) => {
			if(data.success){
				$('.image-container').remove();
				$('.image-upload-field-container').removeClass('d-none');
				toastr.success('Bild wurde entfernt.');
			}else{
				toastr.error('Bild wurde nicht entfernt.');
			}
		}
	);
}